<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li v-for="(breadcrumb, index) in breadcrumbs" :key="index" class="breadcrumb-item">
        <a v-if="breadcrumb.url" :href="breadcrumb.url">{{ breadcrumb.label }}</a>
        <span v-else>{{ breadcrumb.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
interface Breadcrumb {
  label: string;
  url?: string;
}

const props = defineProps<{
  breadcrumbs: Breadcrumb[];
}>();
</script>

<style scoped lang="scss">
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  list-style: none;
  background-color: transparent;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: "/";
  padding: 0 0.5rem;
  color: #6c757d;
}

.breadcrumb-item a {
  color: var(--Grey-Dark-Grey_Secondary, #838383);

  /* Body/Body 2/Regular */
  font-family: "Albert Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.breadcrumb-item > span {
   color: var(--Grey-Dark-Grey, #595757);

   /* Body/Body 2/Semibold */
   font-family: "Albert Sans";
   font-size: 14px;
   font-style: normal;
   font-weight: 600;
   line-height: 20px; /* 142.857% */
 }
</style>
